import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { CustomerShareIndicadorMultiselectComponent } from './customer-share-indicador-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        CustomerShareIndicadorMultiselectComponent
    ],
    exports: [
        CustomerShareIndicadorMultiselectComponent
    ]
})
export class CustomerShareIndicadorMultiselectModule { }
